import { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Filter, X } from "lucide-react";

export const FILTROS_VAZIOS = { status: "pendente", ano: "", mes: "", mesCurso: "", uf: "", ufCurso: "", curso: "", revisao: false };

export const MESES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const STATUS = [
  { k: "pendente", label: "Pendentes", cor: "bg-amber-500" },
  { k: "emitida", label: "Emitidas", cor: "bg-emerald-500" },
  { k: "cancelada", label: "Canceladas", cor: "bg-slate-700" },
  { k: "todos", label: "Todas", cor: "bg-slate-500" },
];

export function Sel({ label, value, onChange, testid, className = "", children }) {
  return (
    <label className={`flex flex-col gap-1 ${className}`}>
      <span className="text-[10px] uppercase tracking-widest font-bold text-slate-500">{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)} className="h-9 rounded-lg border border-slate-200 bg-white px-2 text-sm" data-testid={testid}>
        {children}
      </select>
    </label>
  );
}

function StatusBotoes({ f, set }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Filter className="w-4 h-4 text-slate-500" />
      <span className="text-sm font-bold text-slate-700 mr-2">Status:</span>
      {STATUS.map((s) => (
        <button key={s.k} onClick={() => set("status")(s.k)} data-testid={`fiscal-filtro-${s.k}`}
          className={`px-3 py-1.5 rounded-lg text-sm font-bold transition-colors ${f.status === s.k ? `${s.cor} text-white shadow` : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}>
          {s.label}
        </button>
      ))}
      <label className="ml-auto inline-flex items-center gap-2 text-sm font-bold text-slate-700 cursor-pointer">
        <input type="checkbox" checked={f.revisao} onChange={(e) => set("revisao")(e.target.checked)} className="rounded accent-red-500" data-testid="fiscal-filtro-revisao" />
        Só precisam revisão
      </label>
    </div>
  );
}

export function FiscalFiltros({ f, setF, cursos, todosCursos = [], ufsCliente, ufsCurso }) {
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  const anos = useMemo(() => {
    const y = new Date().getFullYear();
    const s = new Set([y + 1, y, y - 1]);
    todosCursos.forEach((c) => { const a = Number((c.mes || "").slice(0, 4)); if (a) s.add(a); });
    return [...s].sort((a, b) => b - a);
  }, [todosCursos]);
  const ativos = f.ano || f.mes || f.mesCurso || f.uf || f.ufCurso || f.curso || f.revisao;
  const meses = MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>);
  return (
    <Card className="p-4 rounded-2xl space-y-3">
      <StatusBotoes f={f} set={set} />
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-2">
        <Sel label="Ano" value={f.ano} onChange={set("ano")} testid="fiscal-filtro-ano">
          <option value="">Todos</option>
          {anos.map((a) => <option key={a} value={a}>{a}</option>)}
        </Sel>
        <Sel label="Mês da venda" value={f.mes} onChange={set("mes")} testid="fiscal-filtro-mes">
          <option value="">Todos</option>{meses}
        </Sel>
        <Sel label="Mês do curso" value={f.mesCurso} onChange={set("mesCurso")} testid="fiscal-filtro-mes-curso">
          <option value="">Todos</option>{meses}
        </Sel>
        <Sel label="Estado do cliente" value={f.uf} onChange={set("uf")} testid="fiscal-filtro-uf">
          <option value="">Todos</option>
          {ufsCliente.map((u) => <option key={u} value={u}>{u}</option>)}
        </Sel>
        <Sel label="Local do curso" value={f.ufCurso} onChange={set("ufCurso")} testid="fiscal-filtro-uf-curso">
          <option value="">Todos</option>
          {ufsCurso.map((u) => <option key={u} value={u}>{u}</option>)}
        </Sel>
        <Sel label={`Curso (${cursos.length})`} value={f.curso} onChange={set("curso")} testid="fiscal-filtro-curso" className="col-span-2">
          <option value="">Todos</option>
          {cursos.map((c) => <option key={c.id} value={c.id}>{c.rotulo}</option>)}
        </Sel>
      </div>
      {ativos && (
        <div className="flex justify-end">
          <button onClick={() => setF((x) => ({ ...FILTROS_VAZIOS, status: x.status }))} data-testid="fiscal-limpar-filtros"
            className="text-xs font-bold text-slate-500 hover:text-slate-800 inline-flex items-center gap-1">
            <X className="w-3 h-3" /> Limpar filtros
          </button>
        </div>
      )}
    </Card>
  );
}
